import React, { useEffect, useState } from "react";
import { Collapse, Alert, Button } from "react-bootstrap";

const TravelGrantCMS = () => {
  const BASE_URL = "https://admin.vascularirdoctors.com/backend";

  const [collapseBtn, setCollapseBtn] = useState(true);
  const [loading, setLoading] = useState(false);

  const [alert, setAlert] = useState({
    show: false,
    type: "",
    text: "",
  });

  const [formData, setFormData] = useState({
    page_title: "",
    page_subtitle: "",
    highlight_title: "",
    recipient_name: "",
    recipient_institute: "",
    recipient_event: "",
    about_title: "",
    about_content_1: "",
    about_content_2: "",
    scope_title: "",
    scope_items: "",
    eligibility_title: "",
    eligibility_items: "",
    documents_title: "",
    documents_items: "",
    notes_title: "",
    notes_items: "",
    button_text: "",
    button_link: "",
  });

  const [editId, setEditId] = useState(null);

  // ALERT
  const showAlert = (type, text) => {
    setAlert({ show: true, type, text });
    setTimeout(() => {
      setAlert({ show: false, type: "", text: "" });
    }, 3000);
  };

  // FETCH EXISTING DATA
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await fetch(`${BASE_URL}/travel-grant`);
      const data = await res.json();

      if (data && data.id) {
        setEditId(data.id);
        setFormData(data);
      }
    } catch (err) {
      console.log("FETCH ERROR:", err);
    }
  };

  // HANDLE CHANGE
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(
        editId
          ? `${BASE_URL}/travel-grant/${editId}`
          : `${BASE_URL}/travel-grant`,
        {
          method: editId ? "PUT" : "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Saved successfully");
        fetchData();
      } else {
        showAlert("danger", result.message || "Error saving data");
      }
    } catch (err) {
      console.log(err);
      showAlert("danger", "Server error");
    }

    setLoading(false);
  };

  return (
    <div className="row">
      {/* ALERT */}
      {alert.show && (
        <div className="col-xl-12">
          <Alert variant={alert.type}>{alert.text}</Alert>
        </div>
      )}

      <div className="col-xl-12">
        <div className="filter cm-content-box box-primary">

          {/* HEADER */}
          <div className="content-title d-flex justify-content-between align-items-center">
            <div className="cpa">
              <i className="fas fa-globe me-2"></i>International Travel Grant   
            </div>

            <button
              className="btn btn-sm btn-light border"
              onClick={() => setCollapseBtn(!collapseBtn)}
            >
              <i className={`fas ${collapseBtn ? "fa-angle-up" : "fa-angle-down"}`}></i>
            </button>
          </div>

          <Collapse in={collapseBtn}>
            <div className="card-body">

              <form onSubmit={handleSubmit}>
                <div className="row">

                  {/* ===== TITLE ===== */}
                  <div className="col-md-6 mb-3">
                    <label>Page Title</label>
                    <input
                      className="form-control"
                      name="page_title"
                      value={formData.page_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label>Subtitle</label>
                    <input
                      className="form-control"
                      name="page_subtitle"
                      value={formData.page_subtitle}
                      onChange={handleChange}
                    />
                  </div>

                  {/* ===== HIGHLIGHT ===== */}
                  <div className="col-md-4 mb-3">
                    <label>Highlight Title</label>
                    <input
                      className="form-control"
                      name="highlight_title"
                      value={formData.highlight_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>Recipient Name</label>
                    <input
                      className="form-control"
                      name="recipient_name"
                      value={formData.recipient_name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>Institute</label>
                    <input
                      className="form-control"
                      name="recipient_institute"
                      value={formData.recipient_institute}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label>Event</label>
                    <input
                      className="form-control"
                      name="recipient_event"
                      value={formData.recipient_event}
                      onChange={handleChange}
                    />
                  </div>

                  {/* ===== ABOUT ===== */}
                  <div className="col-md-12 mb-3">
                    <label>About Title</label>
                    <input
                      className="form-control"
                      name="about_title"
                      value={formData.about_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label>About Paragraph 1</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      name="about_content_1"
                      value={formData.about_content_1}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label>About Paragraph 2</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      name="about_content_2"
                      value={formData.about_content_2}
                      onChange={handleChange}
                    />
                  </div>

                  {/* ===== LIST FIELDS ===== */}
                  {[
                    ["Scope", "scope_title", "scope_items"],
                    ["Eligibility", "eligibility_title", "eligibility_items"],
                    ["Documents", "documents_title", "documents_items"],
                    ["Notes", "notes_title", "notes_items"],
                  ].map(([label, titleKey, itemsKey], i) => (
                    <React.Fragment key={i}>
                      <div className="col-md-6 mb-3">
                        <label>{label} Title</label>
                        <input
                          className="form-control"
                          name={titleKey}
                          value={formData[titleKey]}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label>{label} Items (use | separator)</label>
                        <textarea
                          className="form-control"
                          rows="3"
                          name={itemsKey}
                          value={formData[itemsKey]}
                          onChange={handleChange}
                        />
                      </div>
                    </React.Fragment>
                  ))}

                  {/* ===== BUTTON ===== */}
                  <div className="col-md-6 mb-3">
                    <label>Button Text</label>
                    <input
                      className="form-control"
                      name="button_text"
                      value={formData.button_text}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label>Button Link</label>
                    <input
                      className="form-control"
                      name="button_link"
                      value={formData.button_link}
                      onChange={handleChange}
                    />
                  </div>

                  {/* SUBMIT */}
                  <div className="col-12 text-end">
                    <button
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save Travel Grant"}
                    </button>
                  </div>

                </div>
              </form>

            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default TravelGrantCMS;